import { EmploymentStatusEnum, ExternalCustomer, Maybe } from '../gql/generated/graphql';

const sameEmail = (buyer?: Maybe<ExternalCustomer>, cobuyer?: Maybe<ExternalCustomer>) => {
  const buyerEmail = buyer?.email?.trim().toLowerCase();
  const cobuyerEmail = cobuyer?.email?.trim().toLowerCase();
  return !!buyerEmail && !!cobuyerEmail && buyerEmail === cobuyerEmail;
};

const getTimeAtLabel = (status: EmploymentStatusEnum) => {
  switch (status) {
    case EmploymentStatusEnum.Employed:
      return 'TIME AT EMPLOYER?';
    case EmploymentStatusEnum.NotEmployed:
      return 'TIME NOT EMPLOYED?';
    case EmploymentStatusEnum.Retired:
      return 'TIME RETIRED?';
    default:
      return 'TIME AT EMPLOYER?';
  }
};

export { sameEmail, getTimeAtLabel };
